export default "__VITE_ASSET__aee1f742__"